module.exports = __webpack_public_path__ + "static/icons/icon-info--circle-d8208fabeaee01148c44848a1d51e1cf.svg";